module.exports = __webpack_public_path__ + "img/camp07_close.dce805b7.png";